<template>
	<div class="footer">
		<div class="main">
			<el-row>
				<el-col :span="17">
					<div class="footer_logo" v-if="detail_logo_qrcode[1].icon.indexOf('profile') > -1">
						<el-image :src="detail_logo_qrcode[1].icon" :title="detail_logo_qrcode[1].title" style="height: 60px;" fit="contain">
							<div slot="error" class="image-slot">
							</div>
						</el-image>
					</div>
					<div class="footer_menu">
						<!-- 关于强企宝典 -->
						<div style="margin-top: 5px;">
							<span v-for="(item, index) in detail_footer.guanyu" :key="index">
								<span style="cursor: pointer;" @click="toUrl(item.url)">{{item.title}}</span>
								<span v-show="(index+1) < detail_footer.guanyu.length"> | </span>
							</span>
						</div>
						<!-- 合作伙伴 -->
						<div>
							合作伙伴：
							<span v-for="(item, index) in detail_footer.hezuo" :key="index">
								<a :href="item.url" class="a_fff" target="_blank">{{item.title}}</a>&nbsp;
							</span>
						</div>
					</div>
					<div class="footer_copy">
						Copyright &copy; 2022 强企宝典 All Rights Reserved qqbd.vip
						<br/>
						备案号：<a href="https://beian.miit.gov.cn/" class="a_fff" target="_blank" rel="nofollow">鲁ICP备2022010625号-1</a> 营业执照信用代码：91370100MA7HHQEAXQ
					</div>
				</el-col>
				<el-col :span="7">
					<div class="footer_qrcode">
						<el-image :src="detail_logo_qrcode[2].icon" style="height: 80px;" fit="contain">
							<div slot="error" class="image-slot">
							</div>
						</el-image>
					</div>
					<div class="footer_qrcode_text">
						{{detail_logo_qrcode[2].title}}
					</div>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				detail_footer: {'guanyu': [], 'hezuo': []},
				detail_logo_qrcode: [{'title': '', 'icon': '', 'summary': ''}, {'title': '', 'icon': '', 'summary': ''}, {'title': '', 'icon': '', 'summary': ''}],
			}
		},
		
		created() {
			
		},
		
		mounted() {
			this.loadMenu('10075', 'detail_footer')
			this.loadMenu('10088', 'detail_logo_qrcode')
		},
		
		methods: {
			// 加载菜单下配置数据
			loadMenu(config_id, return_obj) {
				let url = this.$common.apiUrl + 'pub_web_config/detail/' + config_id
				this.$axios.get(url).then((res) => {
					let list = eval('(' + res.data.data.configJson + ')')
					if (return_obj == 'detail_footer') {
						this.detail_footer = list
						// console.log(this.detail_footer)
					}
					if (return_obj == 'detail_logo_qrcode') {
						this.detail_logo_qrcode = list
						this.detail_logo_qrcode.forEach((item, index) => {
							item.icon = this.$common.adimgUrl + item.icon
						})
					}
				})
			},
			
			// web配置数据链接跳转
			toUrl(url) {
				// console.log(url)
				if (url.indexOf('http') > -1) {
					location.href = url
				} else {
					this.$router.push({path: url})
					setTimeout(()=>{
						location.reload()
					}, 300)
				}
			},
			
			
		}
	}
</script>

<style>
</style>